import React from 'react';
import { injectIntl } from 'react-intl';
import { useAppContext } from 'appContext';

/**
 * Currency field with label and tooltip
 * @param intl
 *  Translate Function
 * @param match {Object}
 *
 * @return {JSX.Element}
 * @constructor
 */
function CurrencyInput({
  label,
  tooltip,
  initialValue,
  onChange,
  onCurrencyKeyDown,
  inputProps,
  intl,
}) {
  const { name, id } = inputProps;
  const { currencySettings: { currencySign } } = useAppContext();
  return (
    <div className="form-group search-form__input currency-format">
      {label
        && (
        <span className="form-group__label__tooltip">
          <label className="form-group__label" htmlFor="salary">
            <span className="form-group__label__title">
              {label}
            </span>
          </label>
          { tooltip }
        </span>
        )}
      <div className="form-group__input">
        <span className="text-ellipsis">
          { currencySign }
        </span>
        <input
          type="text"
          name={name}
          id={id}
          value={initialValue}
          autoComplete="off"
          placeholder={intl.formatMessage({ id: 'Form.SalaryPlaceholder' })}
          onChange={onChange}
          onKeyUp={onChange}
          onKeyDown={onCurrencyKeyDown}
          data-rs-input-highlight
        />
      </div>
    </div>
  );
}

export default injectIntl(CurrencyInput);
